import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { SetTPVCompleteDataTy, TPVOrderData } from '../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import useEditDeleteModal from '../../../../../../../utils/hooks/useEditDeleteModal'
import { useCallback, useState } from 'react'
import ModalSellTicketListingTPV from './ModalSellTicketListingTPV'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { parsedTicketTableData } from '../../functions'
import { getAntiUnsave } from '../../../../../../../utils/reducers/getters'
import { changeErrorMessage, showAntiUnsaveModal } from '../../../../../../../utils/reducers/reduxDispatch'
import { HandleSellRefundTicketTy, HandleSellTicketTy } from './types'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import TwinIcon from '../../../../../../../baseComponents/TwinIcon'
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons'
import { InputWithLabel } from '../../../../../../../forms/Input'
import '../SCDashboardTPV.sass'

interface SellTicketSearcherTPVDSBProps extends SellTicketSearcherTPVDSBLogicProps { 
    title: string
    completeData: TPVOrderData
}

const SellTicketSearcherTPVDSB: React.FC<SellTicketSearcherTPVDSBProps> = ({ setCompleteData, completeData, title}) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal, handleSelectTicket, handleSelectTicketRefund, handleOpenSellTicketSearcherModal, ticketNumber, setTicketNumber, searchSpecificTicket } = useSellTicketSearcherTPVDSBLogic({ setCompleteData })
    return (
        <div className='flex flex-auto flex-col overflow-hidden'>
            <div className='flex items-center pb-5'>
                <h3 className=''>{title}</h3>
                <div className='ml-auto cursor-pointer text-green-43 items-center flex' onClick={handleOpenSellTicketSearcherModal}>
                    <TwinIcon icon={faMagnifyingGlass} className='mr-5' />
                    <span><TwinTrans transKey='search'>Buscar</TwinTrans></span>
                </div>
            </div>
            <div>
                <InputWithLabel className='ticket_number_selector min-w-210' value={ticketNumber} label={t('reference', 'Referencia')} onChange={setTicketNumber} onKeyDown={searchSpecificTicket} autoFocus placeholder={t('ticketNumber', 'Nº de ticket')} hideLabel={true} />
            </div> 
            {openModal?.type === 'edit' ? <ModalSellTicketListingTPV setOpened={() => setOpenModal(null)} onSubmit={() => { }} handleSelectTicket={handleSelectTicket} handleSelectTicketRefund={handleSelectTicketRefund} completeData={completeData} /> : null}
        </div>
    )
}

interface SellTicketSearcherTPVDSBLogicProps {
    setCompleteData: SetTPVCompleteDataTy
}

const useSellTicketSearcherTPVDSBLogic = ({ setCompleteData }: SellTicketSearcherTPVDSBLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [ticketNumber, setTicketNumber] = useState<string>('')
    const { t } = useTwinTranslation()
    const errorSearch = t('ticketNotFound', 'No se ha encontrado el nº de ticket')

    const handleOpenSellTicketSearcherModal = useCallback(() => {
        const errors = getAntiUnsave()
        if(Object.keys(errors).length){
            showAntiUnsaveModal(() => {
                setOpenModal({ type: 'edit', allRowData: {} })
                setCompleteData((old) => {
                    const copyOld = JSON.parse(JSON.stringify(old))
                    copyOld.lastProductIndex = null
                    copyOld.header = {}
                    copyOld.tableData = []
                    copyOld.Customer = {}
                    delete copyOld.selectedTableData
                    parsedTicketTableData(copyOld)
                    return copyOld
                })
            })
        } else {
            setOpenModal({ type: 'edit', allRowData: {} })
        }
    }, [setOpenModal, setCompleteData])
    
    const handleSelectTicket: HandleSellTicketTy = useCallback(async (TicketId, full_assigned_number) => {
        if (TicketId) {
            const result = await twinFetchPostJSON('/api/app/order/tpv/sellTicket/getSellTicketComplete', { id: TicketId, full_assigned_number })
            if (result) {
                setCompleteData((old) => {
                    const copyOld = JSON.parse(JSON.stringify(old))
                    copyOld.header = result.header
                    copyOld.tableData = result.tableData
                    copyOld.lastProductIndex = null
                    parsedTicketTableData(copyOld)
                    return copyOld
                })
                setOpenModal(null)
            }
        }
    }, [setCompleteData, setOpenModal])

    const handleSelectTicketRefund: HandleSellRefundTicketTy = useCallback(async (TicketId, full_assigned_number) => {
        if (TicketId) {
            const result = await twinFetchPostJSON('/api/app/order/tpv/sellTicketRefund/getSellTicketRefundComplete', { id: TicketId, full_assigned_number })
            if (result) {
                setCompleteData((old) => {
                    const copyOld = JSON.parse(JSON.stringify(old))
                    copyOld.header = result.header
                    copyOld.tableData = result.tableData
                    copyOld.lastProductIndex = null
                    parsedTicketTableData(copyOld)
                    return copyOld
                })
                setOpenModal(null)
            }
        }
    }, [setCompleteData, setOpenModal])

    const searchSpecificTicket = useCallback(async (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            let result = null
            if (ticketNumber) {
                result = await twinFetchPostJSON('/api/app/order/tpv/sellTicket/getSpecificSellTicket', {
                    full_assigned_number: ticketNumber.trim()
                })
            }
            if (result && result.id) {
                handleSelectTicket(result.id, result.full_assigned_number)
                setTicketNumber('')
            } else {
                changeErrorMessage(errorSearch)
            }
        }
    }, [ticketNumber, setTicketNumber, handleSelectTicket, errorSearch])

    return { openModal, setOpenModal, handleSelectTicket, handleSelectTicketRefund, handleOpenSellTicketSearcherModal, ticketNumber, setTicketNumber, searchSpecificTicket }
}


export default SellTicketSearcherTPVDSB
